export default __webpack_public_path__ + "static/media/100_1251.b4e3eb01.jpg";